module.exports = __webpack_public_path__ + "img/1562727681.29491a9f.jpg";